import styled from "styled-components";

export const GridLayotCol = styled.div`
    display: grid;
    grid-template-columns: ${p => p.col};
    gap: ${p => p.gap};
`